import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { STATS } from "@/data/content";

export const StatsStrip = () => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.25 });
    return (
        <section
            ref={ref}
            className="relative border-y border-black/[0.08] bg-white"
            data-testid="stats-strip"
        >
            <div className="mx-auto max-w-7xl container-px py-10 lg:py-12 grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
                {STATS.map((s, i) => (
                    <motion.div
                        key={s.label}
                        initial={{ opacity: 0, y: 8 }}
                        animate={inView ? { opacity: 1, y: 0 } : {}}
                        transition={{
                            duration: 0.45,
                            delay: i * 0.06,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                        className="flex flex-col gap-2"
                    >
                        <div className="font-display text-4xl sm:text-5xl text-[hsl(var(--text))] tracking-[-0.02em] leading-none num-tabular">
                            {inView ? (
                                <CountUp
                                    end={s.value}
                                    duration={1.6}
                                    decimals={s.decimals || 0}
                                />
                            ) : (
                                0
                            )}
                            <span className="text-[hsl(var(--gold))] ml-0.5">
                                {s.suffix}
                            </span>
                        </div>
                        <div className="text-[12px] uppercase tracking-[0.18em] font-mono text-[hsl(var(--text-subtle))]">
                            {s.label}
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default StatsStrip;
